<nav [class.thin]="isCollapsed()">
    <div class="navButtonContainer">
        <a class="mainNavButton" routerLinkActive="active" routerLink="/dashboard">
            <i class="icon far fa-home fa-fw"></i>
            <span class="text">{{ 'sidebar.dashboard' | translate }}</span>
        </a>
    </div>

    <div class="navButtonContainer" *appPermission="'sidebar.listings'">
        <div class="mainNavButton" routerLinkActive="active">
            <a routerLink="/listings">
                <i class="icon far fa-hotel fa-fw"></i>
                <span class="text">{{ 'sidebar.listings' | translate }}</span>
            </a>
        </div>
    </div>

    <div class="navButtonContainer" *appPermission="'sidebar.users'">
        <div class="mainNavButton" routerLinkActive="active">
            <a routerLink="/users">
                <i class="icon far fa-users fa-fw"></i>
                <span class="text">{{ 'sidebar.users' | translate }}</span>
            </a>
        </div>
    </div>

    <div class="navButtonContainer" *appPermission="'sidebar.settings'">
        @if (isShiji !== undefined) {
            <div class="mainNavButton" routerLinkActive="active">
                <a [routerLink]="isShiji ? '/settings' : '/settings/fields'">
                    <i class="icon far fa-gears fa-fw"></i>
                    <span class="text">{{ 'sidebar.settings' | translate }}</span>
                </a>
            </div>
        }
    </div>

    <div class="navButtonContainer" *appPermission="'sidebar.exports'">
        <div class="mainNavButton" routerLinkActive="active">
            <a [routerLink]="isShiji ? '/export-management' : '/export-management/exports-monitoring'">
                <i class="icon far fa-folder-arrow-up fa-fw"></i>
                @if (isShiji) {
                    <span class="text">{{ 'sidebar.monitoring' | translate }}</span>
                } @else {
                    <span class="text">{{ 'sidebar.exports' | translate }}</span>
                }
            </a>
        </div>
    </div>

    <div class="navButtonContainer">
        @if (!isShiji && hasAccessToIce) {
            <div class="mainNavButton image" routerLinkActive="active">
                <a routerLink="/icePortal" skipLocationChange>
                    <img alt="iceportal" [src]="IMAGES.LOGOS.ICE_LOGO_WHITE_PNG" />
                </a>
            </div>
        }
    </div>

    <div class="navButtonContainer">
        @if (!isShiji && hasAccessToDal) {
            <div class="mainNavButton image" routerLinkActive="active">
                <a routerLink="/dal" skipLocationChange>
                    <img alt="dal" [src]="IMAGES.LOGOS.DAL_LOGO_WHITE_PNG" />
                </a>
            </div>
        }
    </div>

    <div class="navButtonContainer">
        <div class="mainNavButton" routerLinkActive="active">
            <div class="link" (click)="openHelpTab()">
                <i class="icon far fa-question-circle fa-fw"></i>
                <span class="text">{{ 'sidebar.help' | translate }}</span>
            </div>
        </div>
    </div>
</nav>

<button
    type="button"
    class="expandToggle"
    [class.expanded]="isExpanded()"
    (click)="toggleExpanded()"
    [attr.aria-expanded]="isExpanded()"
    [attr.aria-label]="(isExpanded() ? 'sidebar.collapse' : 'sidebar.expand') | translate"
>
    <i class="far fa-chevron-right fa-fw"></i>
</button>
